import { render, staticRenderFns } from "./ChangeContactInfoCard.vue?vue&type=template&id=4d8df552"
import script from "./ChangeContactInfoCard.vue?vue&type=script&lang=js"
export * from "./ChangeContactInfoCard.vue?vue&type=script&lang=js"
import style0 from "./ChangeContactInfoCard.vue?vue&type=style&index=0&id=4d8df552&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports